// extracted by mini-css-extract-plugin
export default {"deleteOverlay":"j3-z","cancel":"k3-z","disabled":"l3-z","delete":"m3-z"};